import { render } from "./Avataars.vue?vue&type=template&id=7a3b12f4"
import script from "./Avataars.vue?vue&type=script&lang=js"
export * from "./Avataars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__